export const SUPABASE_URL = "https://zyfhaoywgxjfqxunirda.supabase.co";

export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp5Zmhhb3l3Z3hqZnF4dW5pcmRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMxMTk0NTEsImV4cCI6MjA5ODY5NTQ1MX0.Lsg2U840--7KF4CoIcUIPy8Z-UZFRpK8TT1O1nNGWaU";

export const supa = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: window.sessionStorage,
    persistSession: true,
    autoRefreshToken: true
  }
});

// Objeto mutable (en vez de "let" sueltos) porque varios módulos necesitan
// reasignar estos campos, y un import de ES modules no permite reasignar un
// binding importado directamente — solo mutar una propiedad del objeto.
export const cloudState = {
  tenantId: null,       // se llena al iniciar sesión
  syncTimer: null,
  syncEnPausa: true,    // true mientras cargamos datos de la nube, para no re-subirlos de inmediato
};
